import React from "react";
import commonPopupStore from "../common/popup/store/CommonPopupStore";
import FileUploadPopup, {PopupFileUploadParam} from "../common/popup/page/FileUploadPopup";
import CommonUtil from "./CommonUtil";
import AlertConfirmPopup from "../common/popup/page/AlertConfirmPopup";
import OZReportViewerPopup, {OZReportViewerPopupParam} from "../common/popup/page/OZReportViewerPopup";
import TbComFileMapngDetail from "../domain/main/com/file/mapng/TbComFileMapngDetail";
import fixErrorImg from "assets/img/img/dummy/HowToFixTheError.png"
import StringUtil from "./StringUtil";
import AlertElecConfirmPopup from "../common/popup/page/AlertElecConfirmPopup";

export default class UIUtil {
    public static alert(message: string | React.JSX.Element) {
        // return new Promise(resolve => {
        //     modalStore.modal(
        //         message,
        //         false,
        //         result => resolve(result)
        //     )
        // });
        return new Promise<boolean>(resolve => {
            this.openPopup(<AlertConfirmPopup confirm={false} message={<p className="msg">{message}</p>}
                                              callback={result => resolve(result)}
                                              key={CommonUtil.getUid()}/>)
        });
    }

    public static confirm(message: string | React.JSX.Element) {
        // return new Promise(resolve => {
        //     modalStore.modal(
        //         message,
        //         true,
        //         result => resolve(result)
        //     )
        // });
        return new Promise<boolean>(resolve => {
            this.openPopup(<AlertConfirmPopup confirm={true} message={<p className="msg">{message}</p>}
                                              callback={result => resolve(result)}
                                              key={CommonUtil.getUid()}/>)
        });
    }

    public static elecConfirm(message: string | React.JSX.Element) {
        // return new Promise(resolve => {
        //     modalStore.modal(
        //         message,
        //         true,
        //         result => resolve(result)
        //     )
        // });
        return new Promise<boolean>(resolve => {
            this.openPopup(<AlertElecConfirmPopup confirm={true} message={<p className="msg">{message}</p>}
                                              callback={result => resolve(result)}
                                              key={CommonUtil.getUid()}/>)
        });
    }

    public static error(message: React.ReactNode, code?: string) {
        // return new Promise(resolve => {
        //     modalStore.modal(
        //         <>{code && <>CODE: {code} <br/></>}{message}</>,
        //         false,
        //         result => resolve(result)
        //     );
        // });

        let replaceMessage: React.ReactNode = message;
        let orgMessage: React.ReactNode;
        if (code === "JEXS0000000" || code === "JEXD3000000") {
            replaceMessage = (<>
                <span className="d-block fs20 fw500 mb10">불편을 드려 죄송합니다.</span>
                <span className="d-block fc-666">
                    일시적 오류가 발생 하였습니다. <br/>
                    잠시만 기다려주세요.
                </span>
            </>);
            orgMessage = message;
        }
        else if(code?.startsWith("TKENC")) {
            replaceMessage = (<>
                <span className="d-block fs20 fw500 mb10">불편을 드려 죄송합니다.</span>
                <span className="d-block fc-666"><img src={fixErrorImg} width={550}/></span>
            </>);
            orgMessage = "";
        }

        return new Promise<boolean>(resolve => {
            this.openPopup(
                <AlertConfirmPopup
                    confirm={false}
                    size={"alert04"}
                    message={
                        <>
                            <img className="visual" src={require('assets/img/char/char_alert04.png')} alt=""/>
                            <p className="msg ta-center">
                                {replaceMessage}
                                {replaceMessage && <br />}
                                <span>
                                    {code && <>응답코드 ({code})</>}
                                    {code && orgMessage && <br />}
                                    {orgMessage && <>응답메시지 : {orgMessage}</>}
                                </span>
                            </p>
                        </>
                    }
                    callback={result => resolve(result)} key={CommonUtil.getUid()}
                />
            )
        });
    }

    public static async getFile(tbComFileMapngDetail: TbComFileMapngDetail) {
        if (tbComFileMapngDetail == null)
            return;
        const fileList: { FILE_NM: string; ORG_FILE_NM: string; }[] = await CommonUtil.execute({
            url: "com_fileDownload",
            data: {
                DWLD_ID: tbComFileMapngDetail.getDwldId()
            }
        })
            .then((value: any) => value.FILE_LIST)
            .catch(value => {
            });
        if (fileList && fileList.length > 0) {
            for (const fileItem of fileList) {
                const {FILE_NM} = fileItem;
                const mineType = tbComFileMapngDetail.mimeType;
                const fileContent = `data:${mineType};base64,${FILE_NM}`

                const response = await fetch(fileContent);
                return await response.blob();
            }
        }
    }

    public static blobToUrl(object: Blob | MediaSource) {
        return URL.createObjectURL(object);
    }

    public static openPopup(attrs: React.ReactElement) {
        commonPopupStore.addModal(attrs);
    }

    public static openFileUploadPopup(attrs: PopupFileUploadParam) {
        this.openPopup(<FileUploadPopup {...attrs} key={CommonUtil.getUid()}/>);
    }

    public static openOZReportViewerPopup(attrs: OZReportViewerPopupParam) {
        this.openPopup(<OZReportViewerPopup {...attrs} key={CommonUtil.getUid()}/>);
    }
}